export default "__VITE_ASSET__vLoZGkor__"